const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.GADGETS)

export const apiGadgetsProducts = {
	fetchGadgetsProducts: async (
		search: IApiSearch = { query: '' },
		pagination: IApiPagination = { page: 1, perPage: 25 },
		filters?: IApiFilters,
		sorting?: ISortingOption,
	): Promise<IApiResponseModel<IGadgetsProductModel[]>> => {
		const searchFilter = createSearchQuery(search.query, search.type)

		const { data, meta } = await apiCommon<IGadgetsProduct[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(
				pagination,
				{ ...filters, ...searchFilter },
				sorting ? { [sorting.key]: sorting.type } : undefined,
			),
		})

		return { data: data.map(GadgetProduct), meta }
	},
	fetchGadgetsProductDetails: async (id: number): Promise<IGadgetsProductDetailsModel> => {
		const { data } = await apiCommon<IGadgetsProductDetails>(`${groupPrefix}/${id}`, {
			method: 'GET',
		})

		return GadgetsProductDetails(data)
	},
	createGadgetsProduct: async (payload: IGadgetsProductCreatePayload): Promise<IGadgetsProductDetailsModel> => {
		const { data } = await apiCommon<IGadgetsProductDetails>(`${groupPrefix}`, {
			method: 'POST',
			body: payload,
		})

		return GadgetsProductDetails(data)
	},
	updateGadgetsProduct: async (payload: IGadgetsProductUpdatePayload): Promise<IGadgetsProductDetailsModel> => {
		const { data } = await apiCommon<IGadgetsProductDetails>(`${groupPrefix}/${payload.id}`, {
			method: 'PATCH',
			body: payload,
		})

		return GadgetsProductDetails(data)
	},
	deleteGadgetsProductsBulk: async (payload: IGadgetsProductDeleteBulkPayload): Promise<void> => {
		await apiCommon(`${groupPrefix}/bulk-delete`, {
			method: 'POST',
			body: { ...payload },
		})
	},
	updateGadgetsProductsStatusBulk: async (payload: IGadgetsProductUpdateStatusBulkPayload): Promise<void> => {
		await apiCommon(`${groupPrefix}/bulk-status`, {
			method: 'POST',
			body: { ...payload },
		})
	},
}
